/**
 * Pill that shows the % change between current and previous period.
 *
 * - Green pill when the trend is "good", red when "bad", neutral if flat.
 * - `invert` flips the polarity for metrics where a decrease is good
 *   (e.g. response time).
 * - Returns `null` when prev is missing/zero — caller must conditionally
 *   render based on Compare toggle state.
 */
import { DeltaStyles } from "./delta.styles";

const TrendUp = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
    <path
      d="M1 7l3-3 2 2 3-4M9 2H6m3 0v3"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TrendDown = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
    <path
      d="M1 3l3 3 2-2 3 4M9 8H6m3 0V5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Delta = ({ curr, prev, invert = false }) => {
  if (prev === undefined || prev === null || prev === 0) return null;
  const diff = ((curr - prev) / prev) * 100;
  const positive = invert ? diff < 0 : diff > 0;
  const variant = diff === 0 ? "flat" : positive ? "up" : "down";
  const Icon = positive ? TrendUp : TrendDown;
  const sign = diff > 0 ? "+" : "";

  return (
    <DeltaStyles className={`delta delta--${variant}`}>
      {diff !== 0 && <Icon />}
      <span>
        {sign}
        {diff.toFixed(1)}%
      </span>
    </DeltaStyles>
  );
};

export default Delta;
